"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var domReady_1 = __importDefault(require("../_util/domReady"));
var useConfig_1 = __importDefault(require("../_util/useConfig"));
var spriteIcons_1 = __importDefault(require("./spriteIcons"));
var prepend = function (el, target) {
    if (target.firstChild) {
        target.insertBefore(el, target.firstChild);
    }
    else {
        target.appendChild(el);
    }
};
var appendSvg = function () {
    var svgContainer = document.createElement('div');
    svgContainer.innerHTML = spriteIcons_1.default;
    var svg = svgContainer.getElementsByTagName('svg')[0];
    if (svg) {
        svg.setAttribute('aria-hidden', 'true');
        svg.style.position = 'absolute';
        svg.style.width = '0px';
        svg.style.height = '0px';
        svg.style.overflow = 'hidden';
        prepend(svg, document.body);
    }
};
// eslint-disable-next-line
// @ts-ignore:next-line
if (typeof window !== 'undefined' && !window.iconfont__svg__inject) {
    // eslint-disable-next-line
    // @ts-ignore:next-line
    window.iconfont__svg__inject = true;
    (0, domReady_1.default)(appendSvg);
}
var Icon = function (props) {
    var name = props.name, className = props.className, style = props.style, _a = props.size, size = _a === void 0 ? 16 : _a, color = props.color;
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var styles = style;
    var colorStyles = {};
    if (size) {
        styles = Object.assign({}, style, { width: "".concat(size, "px"), height: "".concat(size, "px") });
    }
    if (color) {
        colorStyles = {
            '--intl-icon-color': color,
        };
    }
    return (react_1.default.createElement("span", { style: styles, className: (0, classnames_1.default)("".concat(classPrefix, "-icon"), className) },
        react_1.default.createElement("svg", { className: "icon-".concat(name), style: colorStyles },
            react_1.default.createElement("use", { xlinkHref: "#".concat(name) }))));
};
exports.default = Icon;
//# sourceMappingURL=Icon.js.map